import { View, Click, Open } from '../actions'
import { analytics } from './lib'
import { ImtSearchFormField, type ImtSearchFormFieldProperties } from '../objects/ImtSearch'

import { RateAppPrompt } from '../objects/RateAppPrompt'
import { AppUrl } from '../objects/AppUrl'
import { AppPrompt, type PromptType } from '../objects/AppPrompt'

export function RateAppPromptView() {
  return analytics(new View(), new RateAppPrompt())
}

export function AppPromptClick(promptType: PromptType, vertical?: string) {
  return analytics(new Click(), new AppPrompt({ prompt_type: promptType, vertical }))
}

export function ImtSearchFormFieldOpen(field: ImtSearchFormFieldProperties['field']) {
  return analytics(new Open(), new ImtSearchFormField({ field }))
}

export function AppUrlOpen(url: string) {
  return analytics(new Open(), new AppUrl({ url }))
}
